import { render, staticRenderFns } from "./User.vue?vue&type=template&id=7aaf070e"
import script from "./User.ts?vue&type=script&lang=ts&external"
export * from "./User.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports